import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { TemplateModule } from 'src/app/template/template.module';

import { EditionSelectorComponent } from './components/edition-selector/edition-selector.component';
import { EditionService } from './services/edition.service';

@NgModule({

    declarations: [
        EditionSelectorComponent
    ],

    imports: [
        CommonModule,
        SharedModule,
        TemplateModule
    ],

    exports: [
        EditionSelectorComponent
    ],

    providers: [
        EditionService
    ]

})
export class EditionsModule { }
